import axios from "axios";
import {
  getAccessToken,
  setAccessToken,
  endSessionAndRedirect,
} from "../utils/authToken";
/*
  For Development : dev
  For Testing env : test
  For Production Stage  : stage-prod
  For Production  : prod
*/
const status = process.env.REACT_APP_ENV;
// export const awsUrl = "https://gmfceyt8p9.execute-api.ap-south-1.amazonaws.com/test";
export const awsUrl =
  "https://kgi992skq6.execute-api.ap-south-1.amazonaws.com/" + status;
const awsUrlS3 = "https://jkzdxlws1i.execute-api.ap-south-1.amazonaws.com/test";
const aiUrl =
  "https://0t4e1scfle.execute-api.ap-south-1.amazonaws.com/prod/ai-interview";

// ---------------------------------------------------------------------------
// Authentication
// ---------------------------------------------------------------------------
// One interceptor covers every backendApi call in the app, so no call site
// needs to know about tokens.

axios.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    // The backend silently refreshes an expired token and returns the
    // replacement on this header. Missing it would log the user out every
    // 30 minutes.
    const rotated = response.headers?.["x-new-access-token"];
    if (rotated) {
      setAccessToken(rotated);
    }
    return response;
  },
  (error) => {
    const httpStatus = error.response?.status;
    // 401 - the session ended. 403 - signed in, but not allowed here; sending
    // the user back to login is the only useful action the app can take today.
    if (httpStatus === 401 || httpStatus === 403) {
      endSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);

export function backendApiForInterviewQtn(postData) {
  return axios
    .post(aiUrl, postData)
    .then((data) => data.data)
    .then((res) => res);
}

export function backendApi(postData) {
  return axios
    .post(awsUrl, postData)
    .then((data) => data.data)
    .then((res) => res);
}
export const re =
  /^[a-zA-Z0-9+_.-]+@(?!gmail.com)(?!outlook.com)(?!rediffmail.com)(?!hotmail.com)(?!yahoo.com)(?!aol.com)(?!msn.com)[a-zA-Z0-9.-]+$/;
export const emailValidation =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/\S*)?$/;
export const phNum = /^\d{10}$/;

export function backendApiS3Credential(postData) {
  return axios
    .post(awsUrlS3, postData)
    .then((data) => data.data)
    .then((res) => res);
}

//! ------------------------Image Upload API-------------------------------
export function UploadImage(image) {
  return axios
    .post(
      `${imageUploadURL}newUpload?bucket=${process.env.REACT_APP_S3_BUCKET}&bucketPath=${process.env.REACT_APP_BUCKET_PATH}`,
      image,
    )
    .then((data) => data)
    .then((res) => res);
}

//! Image Upload URL

const imageUploadURL =
  "https://75vfqs60v3.execute-api.ap-south-1.amazonaws.com/";

const generateFileName = () => {
  return `${uuidv4()}-${Date.now()}`;
};
const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const uploadToS3 = async (blob) => {
  try {
    const fileName = generateFileName();
    const formData = new FormData();
    formData.append("image", blob, fileName + blob.name);
    const data = await UploadImage(formData);
    return data.data.imageUrl;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};
